/* src/app/app.component.scss */
.space-bottom {
  bottom: 15px;
}
/*# sourceMappingURL=app.component.css.map */
